// src/lib/seo.js
// Lightweight per-page head management (no dependency on react-helmet).
// The prerenderer writes the same tags statically at build time; this keeps
// them correct during client-side navigation.
import { useEffect } from 'react';
import { SITE_URL, SITE_NAME, OG_IMAGE } from '../content/articles.mjs';

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function usePageMeta({ title, description, path, type = 'website' }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;
    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
    }
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:image', OG_IMAGE);
    upsertMeta('name', 'twitter:image', OG_IMAGE);
    if (path != null) {
      const url = `${SITE_URL}${path}`;
      upsertLink('canonical', url);
      upsertMeta('property', 'og:url', url);
    }
  }, [title, description, path, type]);
}
